import React, { useEffect, useState } from 'react';
import classnames from 'classnames';

export default function Banner({ show, title, text, type, delay, leftAction, rightAction, className }) {
  const [display, setDisplay] = useState(show);

  useEffect(() => {
    if (delay) {
      setTimeout(() => setDisplay(false), delay);
    }
  }, [delay]);

  return (
    display && (
      <div
        className={classnames(
          'h-16 w-full px-4 top-0 relative z-1050 grid grid-cols-12 gap-2',
          {
            'bg-green': type === 'primary',
            'bg-red-500': type === 'warning',
            'bg-orange': type === 'notice',
          },
          className,
        )}
      >
        {leftAction && (
          <div
            className={classnames('flex flex-col justify-start my-auto text-left col-span-3', {
              'col-span-4': !rightAction,
            })}
          >
            {leftAction}
          </div>
        )}
        <div
          className={classnames('flex flex-col justify-center text-center font-semibold text-white', {
            'col-span-6 text-center': leftAction && rightAction,
            'col-span-8 text-left': !leftAction || !rightAction,
            'col-span-12 text-center': !leftAction && !rightAction,
          })}
        >
          <div className="font-semibold">{title}</div>
          {text && <span className="block text-sm text-white mt-1">{text}</span>}
        </div>
        {rightAction && (
          <div
            className={classnames('flex flex-col justify-end my-auto text-right col-span-3', {
              'col-span-4': !leftAction,
            })}
          >
            {rightAction}
          </div>
        )}
      </div>
    )
  );
}
